export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'

export const showloader = (data) => {
    return { type: SHOW_LOADER, message: data}
}

export const hideloader = () => {
    return { type: HIDE_LOADER }
}